<template>
  <div>
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>
<script setup>
const { locale } = useI18n();
import { useDisplay } from 'vuetify';
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { ref } from "vue";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const props = defineProps({
  chartData: Object,
  chartUnits: String,
  title: String,
  column: {
    type: Boolean,
    default: false,
  },
  stacked: {
    type: Boolean,
    default: false,
  },
  max: Number,
  min: Number,
  suggestedMax: Number,
  suggestedMin: Number,
});

const { mobile } = useDisplay();

const chartOptions = ref({
  responsive: true,
  maintainAspectRatio: true,
  aspectRatio: mobile.value ? 1 : 2,
  locale: locale.value,
  indexAxis: props.column ? "x" : "y",
  plugins: {
    title: ![undefined, null].includes(props.title)
      ? {
          display: true,
          text: props.title,
          color: "#CB5546",
        }
      : { display: false },
    tooltip: {
      callbacks: {
        label: function (context) {
          return context.formattedValue + " " + props.chartUnits; // Display the units
        },
      },
    },
    legend: {
      display: props.stacked ? true : false,
    },
  },
  scales: props.stacked
    ? { x: { stacked: true }, y: { stacked: true } }
    : props.column
    ? {
        x: {
          beginAtZero: true,
          grid: {
            display: false,
          },
        },
      }
    : {
        y: {
          beginAtZero: true,
          grid: {
            display: false,
          },
        },
      },
});

onBeforeMount(() => {
  // add max and/or min if provided
  ["max", "min", "suggestedMax", "suggestedMin"].forEach((prop) => {
    if (props[prop]) {
      const axis = props.column ? 'y' : 'x';
      if (!(axis in chartOptions.value.scales)) {
        chartOptions.value.scales[axis] = {};
      }
      chartOptions.value.scales[axis][prop] = props[prop];
    }
  });
});
</script>
